export default __webpack_public_path__ + "static/media/learnReact.dc78f131.md";